import { motion } from "framer-motion";

import google from "../asset/Home/google.svg";
import webflow from "../asset/Home/webflow.svg";
import twitch from "../asset/Home/twitch.svg";
import hotjar from "../asset/Home/hotjar.svg";
import github from "../asset/Home/github.svg";
import gitlab from "../asset/Home/gitlab.svg";

const companies = [
  { logo: google, name: "Google" },
  { logo: webflow, name: "Webflow" },
  { logo: twitch, name: "Twitch" },
  { logo: hotjar, name: "Hotjar" },
  { logo: github, name: "GitHub" },
  { logo: gitlab, name: "GitLab" },
];
const scrollingCompanies = [...companies, ...companies];
function TrustedCompanies() {

  return (
    <>
    
      <section className="w-full py-4 sm:py-8 lg:py-14">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
      <div className="overflow-hidden">
<motion.div
  className="flex gap-5 w-max"
  animate={{
    x: ["0%", "-50%"],
  }}
  transition={{
    duration: 20,
    repeat: Infinity,
    ease: "linear",
  }}
>
    {scrollingCompanies.map((company, index) => (
      <motion.div
        key={index}
        whileHover={{
          y: -8,
          scale: 1.04,
        }}
        className="
          shrink-0
          w-[110px]
          md:w-[150px]
          lg:w-[210px]

          bg-white
          border
          border-[#0C020029]

          rounded-xl

          h-[70px]
          md:h-[100px]
          lg:h-[120px]

          flex
          items-center
          justify-center

          transition-all
          duration-300

          hover:shadow-[0_15px_35px_rgba(0,0,0,0.10)]
        "
      >
        <motion.img
          src={company.logo}
          alt={company.name}
          animate={{
            y: [0, -4, 0],
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut",
            delay: index * 0.2,
          }}
          className="h-7 md:h-8 lg:h-10   max-w-[80%] object-contain"
        />
      </motion.div>
    ))}
</motion.div>
</div>
      </div>
    </section>
      <style>{`
@keyframes infinite-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.logo-scroll {
  animation: infinite-scroll 22s linear infinite;
  width: max-content;
}

.logo-scroll:hover {
  animation-play-state: paused;
}
`}</style>
    </>
  
  );
}

export default TrustedCompanies;
